export const SECTIONS: { id: string; label: string }[] = [
  { id: 'accueil', label: 'Accueil' },
  { id: 'deroule', label: 'Déroulé' },
  { id: 'ceremonie', label: 'Cérémonie' },
  { id: 'repas', label: 'Repas' },
  { id: 'cagnotte', label: 'Cagnotte' },
];
